import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import css from "./index.module.css";
import Content from "@components/adminNavigation";
import axios from "axios";
import * as Types from "../../../types";
import { toast } from "sonner";
import { statusText } from "@pages/account/order.info";
import CartProduct from "@components/cartProduct";
import SEO from "@components/seo";

export default function OrderAdmin() {
  const { id } = useParams();
  const [order, setOrder] = useState<Types.Order>();
  const [status, setStatus] = useState<number>(0);

  useEffect(() => {
    axios
      .get(`${import.meta.env.VITE_API_ADM_URL}/order/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setOrder(response.data);
        setStatus(response.data.status);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function convertToDate(isoDate: any) {
    const date = new Date(isoDate);
    return new Intl.DateTimeFormat("ru-Ru", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
    }).format(date);
  }

  const handleSubmit = (event: any) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.set("status", status.toString());

    axios
      .post(`${import.meta.env.VITE_API_ADM_URL}/order/${id}`, formData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((_) => {
        toast.success("Обновлено успешно");
      })
      .catch((error) => {
        console.log(error);
        toast.error("Ошибка обновления");
      });
  };

  return (
    <Content>
      <SEO
        title={"Управление заказом"}
        description={"Админ-панель"}
        ogUrl={`https://рыбныимир.рф/`}
      />

      <h1 className={css.head}>Заказ №{order?.shortID} </h1>
      <div className={css.flex}>
        <div className={css.col1}>
          <div className={css.products}>
            {order?.products.map((item: Types.CartData) => (
              <CartProduct
                id={item.product.id}
                quantity={0}
                prodID={item.product.id}
                image={item.product.images[0]}
                title={item.product.name}
                price={item.product.price}
                unit={item.product.unit}
                unitCart={item.unit}
                count={item.count}
                width={"100%"}
              />
            ))}
          </div>
        </div>

        <div className={css.col2}>
          <Link to={`/manage/user/${order?.user?.uuid}`} className={css.client}>
            <img
              src="https://amu.edu.kz/upload/default-avatar.jpg"
              className={css.avatar}
              alt="avatar"
            />
            <div className={css.textInfo}>
              <h2>{order?.user?.username}</h2>
              <a>{order?.user?.phone}</a>
            </div>
          </Link>

          <form onSubmit={handleSubmit}>
            <div className={css.inputGrid}>
              <label>Статус</label>
              <select
                value={status}
                onChange={(e) => setStatus(parseInt(e.target.value))}
              >
                <option value={0}>{statusText[0]}</option>
                <option value={1}>{statusText[1]}</option>
                <option value={2}>{statusText[2]}</option>
                <option value={3}>{statusText[3]}</option>
                <option value={4}>{statusText[4]}</option>
                <option value={5}>{statusText[5]}</option>
              </select>
            </div>

            <div className={css.inputGrid}>
              <label>Комментарий администратора</label>
              <textarea
                name="adminComment"
                defaultValue={order?.adminComment}
                placeholder="Комментарий (админа или менеджера)"
              />
            </div>

            <button className={css.saveBtn} type="submit">
              Обновить
            </button>
          </form>

          <div className={css.inputGrid}>
            <label>Комментарий клиента</label>
            <b>{order?.comment || "Не указано"}</b>
          </div>

          <Link to={`/manage/organization/${order?.organization?.orgId}`} className={css.inputGrid}>
            <label>Организация <i className="fi fi-rr-arrow-small-right" style={{ position: 'relative', top: 2 }}></i></label>
            <b>{order?.organization?.name || "Не указано"}</b>
          </Link>

          <div className={css.inputGrid}>
            <label>Адрес доставки</label>
            <b>{order?.address || "Не указано"}</b>
          </div>

          <div className={css.inputGrid}>
            <label>Создан</label>
            <b>{convertToDate(order?.createdAt || null)}</b>
          </div>
        </div>
      </div>
    </Content>
  );
}
